import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { firebaseConnect } from 'react-redux-firebase';
import { Link } from 'react-router-dom';
import Notifications from 'react-notification-system-redux';
import Formsy from 'formsy-react';
import Spinner from 'react-spinkit';
import Styles from './styles';
import CenteredWrapper from '../../components/CenteredWrapper';
import JumperButton from '../../components/UIKit/Button';
import FormsyJumperInput from '../../components/Formsy/Input';
import Spacer from '../../components/Spacer';
import Footer from '../../components/Footer';

class Register extends React.Component {
  constructor() {
    super();
    this.state = {
      displayName: '',
      email: '',
      password: '',
      passwordRepeat: '',
      accountCreated: false,
    };

    this.onFormChange = this.onFormChange.bind(this);
  }

  onFormChange(data) {
    this.setState({
      displayName: data.name,
      email: data.email,
      password: data.password,
      passwordRepeat: data.password_repeat,
    });
  }

  onValidRegisterFormSubmit(data) {
    const { firebase } = this.props;
    this.setState({ loading: true });

    return this.props.firebase
      .createUser(
      {
        email: data.email,
        password: data.password,
        displayName: data.name,
      },
      {
        email: data.email,
        displayName: data.name,
      },
      )
      .then(() => {
        // this.setState({ isLoading: false })
        // this is where you can redirect to another route
        firebase
          .auth()
          .currentUser.sendEmailVerification()
          .then(
            () => {
              const user = firebase.auth().currentUser;
              this.setState({ loading: false, accountCreated: true, email: data.email });
              this.props.firebase.pushWithMeta('organizations', {
                name: data.name,
                members: { [user.uid]: true },
                owners: { [user.uid]: true },
              });

              this.props.showNotification(
                Notifications.success({
                  uid: 'account_created',
                  message: 'Account was created successfully',
                  position: 'bc',
                  autoDismiss: 10,
                }),
              );

              firebase.logout();
            },
            (error) => {
              // An error happened.
              firebase.logout();
              this.setState({ loading: false });
            },
          )
          .catch((error) => {
            console.log('there was an error', error);
            Notifications.error({
              message: 'Unexpected error occured',
              position: 'bc',
              autoDismiss: 0,
            });
          });
      })
      .catch(() => {
        this.setState({ loading: false });
        this.props.showNotification(
          Notifications.error({
            uid: this.props.authError.code,
            message: this.props.authError.message,
            position: 'bc',
            autoDismiss: 0,
          }),
        );
      });
  }

  onInvalidRegisterFormSubmit(data) {
    this.props.showNotification(
      Notifications.error({
        message: 'The form contains errors. Please correct them before submitting again',
        position: 'bc',
        autoDismiss: 3,
      }),
    );
  }

  renderForm() {
    return (
      <CenteredWrapper align="center" width={250}>
        <img alt="" style={Styles.logo} src={require('../../assets/images/login-logo.png')} />
        <Formsy
          onChange={this.onFormChange}
          onValidSubmit={(data) => {
            this.onValidRegisterFormSubmit(data);
          }}
          onInvalidSubmit={(data) => {
            this.onInvalidRegisterFormSubmit(data);
          }}
          style={{ width: '100%' }}
        >
          <FormsyJumperInput
            name="name"
            required
            placeholder="display name"
            value={this.state.displayName}
          />
          <FormsyJumperInput
            name="email"
            required
            placeholder="e-mail address"
            validations={{
              isEmail: true,
              maxLength: 50,
            }}
            validationErrors={{
              isEmail: 'You have to type valid email',
              maxLength: 'You can not type in more than 50 characters',
            }}
            value={this.state.email}
          />
          <FormsyJumperInput
            name="password"
            type="password"
            required
            placeholder="password"
            validations={{
              minLength: 8,
              equalsField: 'password_repeat',
            }}
            validationErrors={{
              minLength: 8,
              equalsField: 'Password don`t match',
            }}
            value={this.state.password}
          />
          <FormsyJumperInput
            name="password_repeat"
            type="password"
            required
            placeholder="repeat password"
            validations={{
              minLength: 8,
              equalsField: 'password',
            }}
            validationErrors={{
              minLength: 8,
              equalsField: 'Password don`t match',
            }}
            value={this.state.passwordRepeat}
          />

          <JumperButton formNoValidate type="none">
            CREATE ACCOUNT
          </JumperButton>
          <p style={{ textAlign: 'center', color: 'white', fontSize: 10 }}>
            Already own an account?<br />
            <Link to="/login">Login</Link>
          </p>
        </Formsy>
      </CenteredWrapper>
    );
  }

  renderLoading() {
    return (
      <CenteredWrapper align="center" width={350}>
        <img alt="" style={Styles.logo} src={require('../../assets/images/login-logo.png')} />
        <div style={{ margin: 50 }}>
          <Spinner name="ball-triangle-path" color={Styles.spinnerColor} fadeIn="none" />
        </div>
      </CenteredWrapper>
    );
  }

  renderThanksMessage() {
    return (
      <CenteredWrapper align="center" width={350}>
        <img alt="" style={Styles.logo} src={require('../../assets/images/login-logo.png')} />
        <div style={{ textAlign: 'center', color: 'white' }}>
          <h2 style={Styles.heading}>Account created</h2>
          <p style={Styles.paragraph}>
            Your account was created successfully. We sent activation link to: {this.state.email}
          </p>
          <p style={Styles.paragraph}>
            Check your inbox and follow provided instructions to activate your account
          </p>
        </div>
      </CenteredWrapper>
    );
  }

  renderContents() {
    if (this.state.loading) {
      return this.renderLoading();
    } else if (this.state.accountCreated) {
      return this.renderThanksMessage();
    }

    return this.renderForm();
  }

  render() {
    return (
      <div style={Styles.wrapper}>
        <Spacer />
        {this.renderContents()}
        <Spacer />
        <Footer>
          <a href="/dummy-link" style={{ color: '#476166', fontSize: 10, margin: 10 }}>
            Link
          </a>
          <a href="/dummy-link" style={{ color: '#476166', fontSize: 10, margin: 10 }}>
            Link
          </a>
          <a href="/dummy-link" style={{ color: '#476166', fontSize: 10, margin: 10 }}>
            Link
          </a>
          <a slot="right" href="/dummy-link" style={{ color: '#476166', fontSize: 10, margin: 10 }}>
            Terms and conditions
          </a>
        </Footer>
      </div>
    );
  }
}

const mapStateToProps = ({ firebase: { auth, authError }, router: { location } }) => ({
  auth,
  authError,
  location,
});

const mapDispatchToProps = dispatch => ({
  showNotification: (notification) => {
    dispatch(notification);
  },
});

export default compose(firebaseConnect(), connect(mapStateToProps, mapDispatchToProps))(Register);



// WEBPACK FOOTER //
// ./src/containers/Register/index.js